<script lang="ts" setup>
import ModuleTitle from './ModuleTitle.vue';
</script>

<template>
  <div class="rounded border border-lightblack bg-white p-3">
    <ModuleTitle>
      <img class="h-[18px]" src="~/assets/image/index/title/yqlj.svg" alt="友情链接" />
    </ModuleTitle>
    <div class="mb-2 mt-4 flex items-center justify-between !text-xs">
      <a
        href="https://www.noi.cn/"
        target="_blank"
        class="!text-colorTextSecondary hover:!text-info"
        >NOI官方网站</a
      >
      <a
        href="https://ioinformatics.org/"
        target="_blank"
        class="!text-colorTextSecondary hover:!text-info"
        >IOI官方网站</a
      >
      <a
        href="https://www.ccf.org.cn/"
        target="_blank"
        class="!text-colorTextSecondary hover:!text-info"
        >中国计算机学会官网</a
      >
    </div>
  </div>
</template>
